import EtiquetaService from "@/services/EtiquetaService"

export const actions = {
    cadastrarEtiqueta: ({commit, dispatch}) => {
        commit('setEtiqueta', {
            nome: "",
            template_path: "",
            conteudos: []
        }),
        dispatch('setModalCadastroEtiqueta', true)
    },
    listarEtiquetas: ({commit}, data) => {
        commit('setOverlay', true)
        EtiquetaService.listar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('setEtiquetas', res.data)
        })
        .catch(e => {
            commit('setOverlay', false)
            console.log(e)
        })
    },
    visualizarEtiqueta: ({commit, dispatch}, data) => {
        commit('setEtiqueta', {...data})
        dispatch('setModalCadastroEtiqueta', true)
    },
    salvarEtiqueta: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        EtiquetaService.salvar(data)
        .then(res => {
            commit('addEtiqueta', res.data)
            commit('setEtiqueta', res.data)
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Registro salvo.')
            // dispatch('setModalCadastroEtiqueta', false)
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrar.')
        })
    },
    atualizarEtiqueta: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        EtiquetaService.atualizar(data)
        .then(res => {
            commit('setOverlay', false)
            dispatch('listarEtiquetas')
            commit('setEtiqueta', res.data)
            commit('snackbarInfo', 'Registro atualizado.')
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    excluirEtiqueta: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        dispatch('setModalExcluirEtiqueta', false)
        dispatch('setModalCadastroEtiqueta', false)
        EtiquetaService.excluir(data.id)
        .then(res => {
            commit('removeEtiqueta', data)
            commit('setOverlay', false)
            commit('snackbarError', 'Etiqueta excluído.')
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao excluir.')
        })
    },
    setModalCadastroEtiqueta: ({commit}, status) => {
        commit('setModalCadastrarEtiqueta', false)
        setTimeout(() => {
            commit('setModalCadastrarEtiqueta', status)
        }, 100);
    },
    setModalExcluirEtiqueta: ({commit}, status) => {
        commit('setModalExcluirEtiqueta', false)
        setTimeout(() => {
            commit('setModalExcluirEtiqueta', status)
        }, 100);
    },
    setModalImprimirEtiqueta: ({commit}, status) => {
        commit('setModalImprimirEtiqueta', false)
        setTimeout(() => {
            commit('setModalImprimirEtiqueta', status)
        }, 100);
    },
    imprimirEtiqueta: ({ commit }, payload) => {
        commit("setOverlay", true);
        EtiquetaService.imprimir(payload)
          .then((res) => {
            commit("setOverlay", false);
            commit("setModalPrint", res.data.pdf_link);
          })
          .catch((e) => {
            console.log(e);
            commit("setOverlay", false);
            commit("snackbarError", "Erro ao imprimir.");
          });
      },
}

export default {}